import * as React from "react"

import * as classNames from "./JobAdResult.module.scss"
import Section from "../../../../../../core/layout/main/section/Section"
import Card from "../../../../blocks/card/Card"
import Button from "../../../../blocks/button/Button"
import CardDetails from "../../../../blocks/card/CardDetails"
import Icon from "../../../../blocks/icon/Icon"
import LocationSearchField from "../location-search-field/LocationSearchField"
import TermSearchField from "../term-search-field/TermSearchField"
import { navigate } from "gatsby"
import ContractSearchField from "../contract-search-field/ContractSearchField"

const JobAdResult = ({
  CardTitle,
  CardDescription,
  CardBoutonText,
  data,
  termFilter,
  setTermFilter,
  locationFilter,
  setLocationFilter,
  contractFilter,
  setContractFilter,
  setSearchHistory,
  searchHistory,
}) => {
  function useSearchField(initialState, setFilter) {
    const [showField, setShowField] = React.useState(initialState)

    const show = () => setShowField(true)
    const hide = () => setShowField(false)
    const handleSet = (newTerm) => {
      setFilter(newTerm)
      hide()
    }

    return [showField, show, hide, handleSet]
  }

  const [showSearchField, showSearch, hideSearch, handleSetTerm] =
    useSearchField(false, setSearchHistory)
  const [
    showLocationField,
    showLocationSearch,
    hideLocationSearch,
    handleSetLocation,
  ] = useSearchField(false, setLocationFilter)
  const [showContractField, showContract, hideContract, handleSetContract] =
    useSearchField(false, setContractFilter)

  const [isMobile, setIsMobile] = React.useState(false)

  React.useEffect(() => {
    const updateIsMobile = () => {
      setIsMobile(window.innerWidth < 1080)
    }

    updateIsMobile()

    window.addEventListener("resize", updateIsMobile)

    // Cleanup
    return () => window.removeEventListener("resize", updateIsMobile)
  }, [])

  return (
    <Section
      container={"large"}
      className={classNames.RhJobAdSearchFormSection}
    >
      {!isMobile && (
        <>
          <div class="spacer height-120"></div>
          <div class="spacer height-120"></div>
        </>
      )}
      <div className={classNames.gridContainer}>
        <div className={classNames.filtres}>
          <div className={classNames.filtersPanels}>
            <CardDetails
              title="Poste"
              isOpen
            >
              <div className="mt-3">
                {showSearchField && (
                  <TermSearchField
                    termFilter={termFilter}
                    setTermFilter={setTermFilter}
                    setSearchHistory={handleSetTerm}
                  />
                )}
                <div className={classNames.resulatButton}>
                  {searchHistory.map((item, index) => (
                    <Button
                      key={index}
                      aspect="tag"
                      size="large"
                      color="primary"
                    >
                      <Button
                        onClick={() => {
                          setSearchHistory((prevHistory) =>
                            prevHistory.filter(
                              (historyItem) => historyItem !== item
                            )
                          )
                        }}
                      >
                        <Icon
                          icon="cross"
                          key={"icone_" + index}
                          width="15"
                          height="15"
                        />
                      </Button>
                      {item}
                    </Button>
                  ))}
                  <Button
                    aspect="tag"
                    size="large"
                    color="primary"
                    className={classNames.resulatButton}
                    onClick={showSearch}
                  >
                    <Icon
                      icon="plus"
                      key={"icone_plus"}
                      width="15"
                      height="15"
                    />
                  </Button>
                </div>
              </div>
            </CardDetails>
            <CardDetails
              title="Régions"
              isOpen
              className={classNames.locationCardDetails}
            >
              <div className="mt-3">
                {showLocationField && (
                  <LocationSearchField
                    locationFilter={locationFilter}
                    setLocationFilter={setLocationFilter}
                    setSearchHistory={handleSetLocation}
                    setShowLocationField={hideLocationSearch}
                  />
                )}
              </div>
              <div className="tags mr-1 mt-3">
                {locationFilter.map((item, index) => {
                  return (
                    <Button
                      key={item.label}
                      aspect="tag"
                      size="large"
                      color="primary"
                      className={classNames.resulatButton}
                      onClick={() => {
                        setLocationFilter((old) => {
                          return old.filter((v) => v.label !== item.label)
                        })

                        setContractFilter((old) => {
                          return old.filter((v) => v.label !== item.label)
                        })
                      }}
                    >
                      <Icon
                        icon="cross"
                        width="15"
                        height="15"
                      />
                      {item.label}
                    </Button>
                  )
                })}
                <Button
                  aspect="tag"
                  size="large"
                  color="primary"
                  className={classNames.resulatButton}
                  onClick={showLocationSearch}
                >
                  <Icon
                    icon="plus"
                    key={"icone_plus"}
                    width="15"
                    height="15"
                  />
                </Button>
              </div>
            </CardDetails>
            <CardDetails
              title="Contrat"
              isOpen
              className={classNames.contractCardDetails}
            >
              <div className="mt-3">
                {showContractField && (
                  <ContractSearchField
                    contractFilter={contractFilter}
                    setContractFilter={setContractFilter}
                    setSearchHistory={handleSetContract}
                    setShowContractField={hideContract}
                  />
                )}
                <div className="tags mt-3">
                  {contractFilter.map((item, index) => {
                    return (
                      <Button
                        key={item.label}
                        aspect="tag"
                        size="large"
                        color="primary"
                        className={classNames.resulatButton}
                        onClick={() => {
                          setLocationFilter((old) => {
                            return old.filter((v) => v.label !== item.label)
                          })

                          setContractFilter((old) => {
                            return old.filter((v) => v.label !== item.label)
                          })
                        }}
                      >
                        <Icon
                          icon="cross"
                          width="15"
                          height="15"
                        />
                        {item.label}
                      </Button>
                    )
                  })}
                  <Button
                    aspect="tag"
                    size="large"
                    color="primary"
                    className={classNames.resulatButton}
                    onClick={showContract}
                  >
                    <Icon
                      icon="plus"
                      key={"icone_plus"}
                      width="15"
                      height="15"
                    />
                  </Button>
                </div>
              </div>
            </CardDetails>
            {!isMobile && (
              <Card
                className={`flex text-center p-3 gap-3 ${classNames.freeCandidate}`}
              >
                <p className="fs-20">
                  {CardTitle ? CardTitle : "Candidature spontanée"}
                </p>
                <p className={classNames.freeCandidateDescription}>
                  {CardDescription
                    ? CardDescription
                    : `Paritel est à la recherche de personnes talentueuses, n'hésitez\npas à laisser votre CV !`}
                </p>
                <Button
                  aspect="classique"
                  size="medium"
                  color="primary"
                  onClick={() => {
                    navigate("/pop-in/candidature-1", {
                      state: {
                        modal: true,
                      },
                    })
                  }}
                  className="m-auto"
                >
                  {CardBoutonText ? CardBoutonText : "Déposer mon CV"}
                </Button>
              </Card>
            )}
          </div>
          {isMobile && (
            <Card
              className={`flex text-center p-3 gap-3 ${classNames.freeCandidate}`}
            >
              <p className="fs-20">
                {CardTitle ? CardTitle : "Candidature spontanée"}
              </p>
              <p className={classNames.freeCandidateDescription}>
                {CardDescription
                  ? CardDescription
                  : `Paritel est à la recherche de personnes talentueuses, n'hésitez\npas à laisser votre CV !`}
              </p>
              <Button
                aspect="classique"
                size="medium"
                color="primary"
                onClick={() => {
                  navigate("/pop-in/candidature-1", {
                    state: {
                      modal: true,
                    },
                  })
                }}
                className="m-auto"
              >
                {CardBoutonText ? CardBoutonText : "Déposer mon CV"}
              </Button>
            </Card>
          )}
        </div>
        <div className={classNames.results}>
          {data.map((d) => (
            <Card
              key={d.route}
              type="annonce"
              className="quinary-background-color no-shadow p-3"
            >
              <div className="card__header flex align-items-center mb-3">
                <div className="card__header__title">
                  <p className="fs-24">{d.title}</p>
                </div>
                <span className="ml-auto quartary-text-color">
                  {d.dayDiff < 31
                    ? "il y a " + d.dayDiff + " j"
                    : "plus d'un mois"}
                </span>
              </div>
              <div className="card__content"></div>
              <div className="card__footer flex align-items-center justify-content-space-between mt-auto">
                <div className="tags">
                  {d.city && (
                    <Button
                      aspect="tag"
                      color="primary"
                      size="large"
                    >
                      {d.city.startsWith("Agence de ")
                        ? d.city.split("Agence de ")[1]?.trim()
                        : d.city}
                    </Button>
                  )}
                  {d.contractLabel && (
                    <Button
                      aspect="tag"
                      color="primary"
                      size="large"
                    >
                      {d.contractLabel}
                    </Button>
                  )}
                </div>
                <Button
                  aspect={"contrastant"}
                  color={"primary"}
                  size={"large"}
                  to={d.route}
                >
                  Voir l'annonce
                </Button>
              </div>
            </Card>
          ))}
        </div>
      </div>
      <div class="spacer height-120"></div>
    </Section>
  )
}

export default JobAdResult
